<template>
<div class="chapter">
<div class="inner_page">
<hr/>
<p class="center"><span style="font-size: smaller">A MARINER BOOK</span><br/>
<span style="font-size: smaller">HOUGHTON MIFFLIN COMPANY</span><br/>
<em>Boston New York</em></p>
<hr/>
<p class="center">First Mariner Books edition <span style="font-size: smaller">2003</span><a id="piv"></a> </p>
<p class="center">Copyright © 1997 by Peter Ho Davies<br/>
All rights reserved</p>
<p class="center">For information about permission to reproduce selections from<br/>
this book, write to Permissions, Houghton Mifflin Company,<br/>
215 Park Avenue South, New York, New York 10003.</p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data</em><br/>
Davies, Peter Ho, date<br/>
The ugliest house in the world . stories / Peter Ho Davies.<br/>
p. cm.<br/>
Contents . The ugliest house in the world—<br/>
I don't know, what do you think?—Coventry—A Union<br/>
—Relief—Safe—Buoyancy—The silver screen.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-92480-4<br/>
<span style="font-size: smaller">ISBN</span> 978-0-3959-2480-8<br/>
I. Title.<br/>
<span style="font-size: smaller">PR</span>6054.A89145U4 1997<br/>
813'.54—dc2I 97-12873 <span style="font-size: smaller">CIP</span></p>
<p class="left">Printed in the United States of America</p>
<p class="left"><span style="font-size: smaller">DOH</span> 10 9 8 7 6 5 4 3</p>
<p class="left">The following stories appeared in slightly different form in these<br/>
publications: "The Ugliest House in the World" in <em>Antioch Review,</em><br/>
<em>Critical Quarterly</em> (U.K.), and <em>The Best American Short Stories 1995;</em><br/>
"Relief" in <em>The Paris Review;</em> "Safe" in <em>Agni,</em> "I Don't Know, What<br/>
Do You Think?" in <em>The Greensboro Review;</em> "Buoyancy" in <em>Story,</em><br/>
"The Silver Screen" in <em>Harvard Review</em> and <em>The Best American</em><br/>
<em>Short Stories</em> 1996</p>
<hr/>
<blockquote>
<p class="center"><em>For my parents</em><a id="pv"></a> </p>
</blockquote>
<hr/>
<h1 class="fronttitle">Acknowledgments</h1>
<p class="left">Thanks are due to everyone who has read and commented on these stories but especially to Lynne Raughley, Marshall N. Klimasewiski, Fred Leebron, Kathryn Rhett, and Janet Silver. I am also grateful to the Henfield Foundation and the Fine Arts Work Center in Provincetown for their generous support during the writing of this book.<a id="pvi"></a> </p>
<p class="follow">A number of sources were helpful for the historical stories in this collection, but the following books and their authors proved especially valuable: <em>The Washing of the Spears,</em> by Donald R. Morris; <em>The North Wales Quarrymen 1874-1922,</em> by R. Merfyn Jones; <em>In Patagonia,</em> by Bruce Chatwin; and <em>The War of the Running Dogs,</em> by Noel Barber. Any inaccuracies are my responsibility, as, of course, are the occasional historical liberties I've taken.</p>
<hr/>
<blockquote>
<p class="center">"Use every man after his desert, and who shall 'scape whipping?"<a id="pvii"></a> </p>
<p class="center"><em>Hamlet</em> II, ii</p>
</blockquote>
<hr/>
<h1 class="fronttitle">Contents</h1>
<p class="center"><span style="font-size: smaller">THE UGLIEST HOUSE IN THE WORLD</span> <a href="#/c01#p1">[&gt;]</a><a id="pix"></a> </p>
<p class="center"><span style="font-size: smaller">RELIEF</span> <span href="#/c02#p27" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">A UNION</span> <span href="#/c03#p47" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">SAFE</span> <span href="#/c04#p127" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">I DON'T KNOW, WHAT DO YOU THINK?</span> <span href="#/c05#p145" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">COVENTRY</span> <span href="#/c06#p165" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">BUOYANCY</span> <span href="#/c07#p191" title="Link target outside of Sample">[&gt;]</span></p>
<p class="center"><span style="font-size: smaller">THE SILVER SCREEN</span> <span href="#/c08#p205" title="Link target outside of Sample">[&gt;]</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front.vue?371663eb